module.exports = __webpack_public_path__ + "static/media/Rezepte_Teaser.d73ffbdd.jpg";